import cn from 'classnames';
import { IconButton } from 'seagull';
import { Checkmark } from 'seagull/icons';
import styles from "./ColorSelector.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders a clickable circle filled with a specified color with an optional checked icon
 * to signify the color is selected.
 */
export function ColorSelector(props) {
  const {
    color,
    selected,
    disabled,
    withBorder,
    hasError,
    testid,
    onClick
  } = props;
  return /*#__PURE__*/_jsx(IconButton, {
    className: cn(withBorder && styles.border, hasError && styles.hasError),
    skin: "transparent",
    size: "small",
    noPadding: true,
    disabled: disabled,
    "data-testid": testid,
    onClick: onClick,
    children: /*#__PURE__*/_jsx("div", {
      className: cn(styles.circle, {
        [styles.selected]: selected
      }),
      style: {
        background: color
      },
      children: selected && /*#__PURE__*/_jsx("div", {
        className: styles.checked,
        "data-testid": testid && "".concat(testid, "-checked"),
        children: /*#__PURE__*/_jsx(Checkmark, {
          width: "16",
          height: "16"
        })
      })
    })
  });
}